const exoticWeaponHashesWithCatalyst = new Set<number>([
  17096506, // Dragon's Breath
  19024058, // Prometheus Lens
  46524085, // Osteo Striga
  204878059, // Malfeasance
  219145368, // The Manticore
  331231237, // Finality's Auger
  347366834, // Ace of Spades
  370712896, // Salvation's Grip
  374573733, // Delicate Tomb
  400096939, // Outbreak Perfected
  417164956, // Jötunn
  427899681, // Red Death Reformed
  603721696, // Cryosthesia 77K
  648595258, // Graviton Spike
  776191470, // Tommy's Matchbook
  814876685, // Trinity Ghoul
  940371471, // Wicked Implement
  1034055198, // Necrochasm
  1047932517, // Slayer's Fang
  1111334348, // Ice Breaker
  1234150730, // Trespasser
  1331482397, // MIDA Multi-Tool
  1345867570, // Sweet Business
  1345867571, // Coldheart
  1363238943, // Ruinous Effigy
  1363886209, // Gjallarhorn
  1441805468, // The Navigator
  1473821207, // Revision Zero
  1481594633, // Barrow-Dyad
  1508896098, // The Wardcliff Coil
  1541131350, // Cerberus+1
  1594120904, // No Time to Explain
  1665952087, // The Fourth Horseman
  1681583613, // Ergo Sum
  1685137410, // Heirloom
  1736135946, // New Malpais
  1753923263, // Wolfsbane
  1763584999, // Grand Overture
  1802135586, // Touch of Malice
  1833195496, // Ager's Scepter
  1853180924, // Traveler's Chosen
  1864563948, // Worldline Zero
  1891561814, // Whisper of the Worm
  1912669214, // Centrifuse
  2044500762, // The Queenbreaker
  2084878005, // Heir Apparent
  2130065553, // Arbalest
  2179048386, // Forerunner
  2208405142, // Telesto
  2232171099, // Deathbringer
  2286143274, // The Huckleberry
  2350354266, // Alethonym
  2357297366, // Witherhoard
  2362471601, // Rat King
  2581676735, // New Land Beyond
  2591746970, // Leviathan's Breath
  2603483885, // Cloudstrike
  2694576561, // Two-Tailed Fox
  2812324401, // Dead Messenger
  2816212794, // Bad Juju
  2856683562, // SUROS Regime
  2907129556, // Sturm
  2907129557, // Sunshot
  2910326942, // Wish-Keeper
  2973900274, // Third Iteration
  3089417789, // Riskrunner
  3118061005, // Vexcalibur
  3121540812, // Final Warning
  3141979346, // D.A.R.C.I.
  3141979347, // Borealis
  3211806999, // Izanagi's Burden
  3260753130, // Ticuu's Divination
  3325463374, // Thunderlord
  3413074534, // Polaris Lance
  3413860063, // Lord of Wolves
  3437746471, // Crimson
  3460576091, // Duality
  3512014804, // Lumina
  3524313097, // Eriana's Vow
  3549153978, // Fighting Lion
  3549153979, // The Prospector
  3561203890, // Tessellation
  3580904580, // Legend of Acrius
  3580904581, // Tractor Cannon
  3588934839, // Le Monarque
  3628991658, // Graviton Lance
  3628991659, // Vigilance Wing
  3654674561, // Dead Man's Tale
  3659414143, // Verglas Curve
  3664831848, // Heartshadow
  3698448090, // Choir of One
  3725585710, // Lodestar
  3761898871, // Lorentz Driver
  3766045777, // Black Talon
  3821409356, // Ex Diris
  3844694310, // The Jade Rabbit
  3856705927, // Hawkmoon
  3886719505, // Buried Bloodline
  3899270607, // The Colony
  3973202132, // Thorn
  4017959782, // Symmetry
  4036115577, // Sleeper Simulant
  4068264807, // Monte Carlo
  4124984448, // Hard Light
  4174431791, // Hierarchy of Needs
  4190156464, // Merciless
  4255268456, // Skyburner's Oath
  4284533075, // Service of Luzaku
  4289226715, // Vex Mythoclast
  4293613902, // Quicksilver Storm
]);

export default exoticWeaponHashesWithCatalyst;
